import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './userListHeader.module.scss';

export default memo(function UserListHeader() {
    const [t] = useTranslation(['common', 'users']);

    const options = [{
        dictionary: 'common',
        key: 'GENERAL',
    }, {
        dictionary: 'users',
        key: 'mobile',
    }, {
        dictionary: 'users',
        key: 'extension',
    }, {
        dictionary: 'common',
        key: 'mode',
    }, {
        dictionary: 'common',
        key: 'registered',
    }, {
        dictionary: 'common',
        key: 'voicemail',
    }, {
        dictionary: 'common',
        key: 'forward',
    }, {
        dictionary: 'common',
        key: 'recordings',
    }];

    return (
        <div className={styles.container}>
            <div className={styles.optionContainer}>
                {map(options, (option, index) => (
                    <div key={index} className={styles.option}>
                        <Tooltip disableFocusListener disableTouchListener title={t(`${option.dictionary}:${option.key}`)}>
                            <span>{t(`${option.dictionary}:${option.key}`)}</span>
                        </Tooltip>
                    </div>
                ))}
                <div className={styles.actions}></div>
            </div>
        </div>
    );
});
